import React, { useState, useEffect } from "react";
import {
  Box, Typography, TextField, Button, Grid,
  FormControl, InputLabel, Select, MenuItem,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { createMemberCategory, fetchMemberTypes, fetchBusinessUnitsByDomain } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import { COMPANY_ID } from "../../config/appConfig";

export default function MemberCategoryCreatePage() {
  const { businessDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [memberTypes, setMemberTypes] = useState([]);
  const [businessUnitId, setBusinessUnitId] = useState(null);
  const [form, setForm] = useState({
    memberCategoryName: "",
    memberCategoryDescription: "",
    selectedMemberType: null,
  });

  useEffect(() => {
    (async () => {
      try {
        const [types, units] = await Promise.all([
          fetchMemberTypes(businessDomainId),
          fetchBusinessUnitsByDomain(businessDomainId),
        ]);
        setMemberTypes(Array.isArray(types) ? types : []);
        if (Array.isArray(units) && units.length > 0) {
          setBusinessUnitId(units[0].businessUnitId);
        }
      } catch (e) { /* ignore */ }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessDomainId]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleTypeChange = (e) => {
    const selected = memberTypes.find((mt) => mt.memberTypeId === e.target.value);
    setForm({ ...form, selectedMemberType: selected || null });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createMemberCategory({
        companyId: COMPANY_ID,
        businessDomainId,
        businessUnitId,
        memberCategoryName: form.memberCategoryName,
        memberCategoryDescription: form.memberCategoryDescription || null,
        memberTypeId: form.selectedMemberType?.memberTypeId || null,
        associatedMemberTypes: [],
      });
      notify.success(t("message.create.success"));
      navigate(`/strategy/${businessDomainId}/member-categories`, { replace: true });
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("memberCategory.create.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>

          {/* メンバーカテゴリ名 */}
          <Grid size={12} md={6}>
            <TextField
              fullWidth required
              label={t("memberCategory.name")}
              name="memberCategoryName"
              value={form.memberCategoryName}
              onChange={handleChange}
            />
          </Grid>

          {/* メンバータイプ選択 */}
          <Grid size={12} md={6}>
            <FormControl fullWidth required>
              <InputLabel>{t("memberCategory.memberType")}</InputLabel>
              <Select
                value={form.selectedMemberType?.memberTypeId || ""}
                onChange={handleTypeChange}
                label={t("memberCategory.memberType")}
              >
                {memberTypes.map((mt) => (
                  <MenuItem key={mt.memberTypeId} value={mt.memberTypeId}>
                    {mt.memberTypeName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* 説明 */}
          <Grid size={12}>
            <TextField
              fullWidth multiline rows={3}
              label={t("common.description")}
              name="memberCategoryDescription"
              value={form.memberCategoryDescription}
              onChange={handleChange}
            />
          </Grid>

        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.add")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/strategy/${businessDomainId}/member-categories`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
